<app-language-selector class="language-selector"/>

<div class="card">
    <mat-icon class="error-icon ct-error-icon-animated">cloud_off</mat-icon>
    <h1>{{ 'shared.backend-not-available.title' | translate }}</h1>
    <p>{{ 'shared.backend-not-available.message' | translate }}</p>
    <img class="ubi-logo" src="app_logo_black.svg" alt="UBI Solutions">
    <div class="actions">
        <button mat-flat-button color="primary" (click)="retryNow()" [disabled]="retrying()">
            @if (retrying()) {
                <mat-spinner diameter="20"/>
            } @else {
                <mat-icon>refresh</mat-icon>
            }
            {{ 'shared.backend-not-available.retry' | translate }}
        </button>
        <button mat-button (click)="logout()">
            <mat-icon>logout</mat-icon>
            {{ 'shared.backend-not-available.logout' | translate }}
        </button>
    </div>
    <p class="retry-hint" [class.retry-hint--error]="retryFailed()">
        @if (retrying()) {
            <span>{{ 'shared.backend-not-available.checking' | translate }}</span>
        } @else if (retryFailed()) {
            <mat-icon class="retry-hint__icon">error_outline</mat-icon>
            <span>{{ 'shared.backend-not-available.retry-failed' | translate: { seconds: secondsUntilRetry() } }}</span>
        } @else {
            <span>{{ 'shared.backend-not-available.auto-retry' | translate: { seconds: secondsUntilRetry() } }}</span>
        }
    </p>
</div>
